export const drawingCols = [
  {
    label: "Drawing Title",
    key: "title",
  },
  {
    label: "Drawing #",
    key: "dwgNumber",
  },
  {
    label: "Revision",
    key: "revision",
  },
  {
    label: "Sheet #",
    key: "sheetNumber",
  },
  // {
  //   label: "Discipline",
  //   key: "discipline",
  // },
  {
    label: "Lifecycle",
    key: "lifecycle",
  },
  {
    label: "Source",
    key: "source",
  },
  {
    label: "ID",
    key: "id",
  },
];
